module.exports = __webpack_public_path__ + "img/96.8.TSS.f897a581.png";